import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { createSelector } from 'reselect';
import DeleteModal from '../../Components/Common/DeleteModal';
import SimpleBar from 'simplebar-react';
import CreateActivityButton from './Components/CreateActivityButton';
import ActivityGroupList from './Components/ActivityGroupList';
import FullCalendarView from './Components/FullCalendarView';
import ActivityModal from './Components/ActivityModal';
import ActivityMaintenanceModal from './Components/ActivityMaintenanceModal';
import {
	getActivityList as onGetActivityList,
	addNewActivity as onAddNewActivity,
	deleteActivity as onDeleteActivity,
	updateActivity as onUpdateActivity,
	resetCalendar,
	getActivityGroupList,
} from '../../slices/thunks';
import CreateActivityMaintenanceButton from './Components/CreateActivityMaintenanceButton';

const Calendar = ({ categories, type }) => {
	document.title = 'SPED - Calendario';

	const dispatch = useDispatch();
	const [activity, setActivity] = useState({});
	const [modal, setModal] = useState(false);
	const [modalMaintenance, setModalMaintenance] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);
	const [selectedDay, setSelectedDay] = useState(0);
	const [selectedNewDay, setSelectedNewDay] = useState(0);
	const [isEdit, setIsEdit] = useState(false);
	const [isEditButton, setIsEditButton] = useState(true);
	const [upcomingActivities, setUpcomingActivities] = useState([]);
	const [selectedGroupItem, setSelectedGroupItem] = useState(null);
	const [calendarViewDates, setCalendarViewDates] = useState({ start: null, end: null });

	// Redux Selector
	const selectLayoutState = state => state.Activities;
	const calendarDataProperties = createSelector(selectLayoutState, state => ({
		activities: state.itemActivityList,
		groups: state.itemActivityGroupList,
		isActivityUpdated: state.isActivitySuccess,
	}));
	const { activities, isActivityUpdated, groups } = useSelector(calendarDataProperties);

	// Fetch Activity Groups on component mount
	useEffect(() => {
		dispatch(getActivityGroupList({ categories: categories || [] }));
	}, [dispatch, categories]);

	// Update when activities are updated
	useEffect(() => {
		if (isActivityUpdated) {
			setIsEdit(false);
			setActivity({});
			
			if (calendarViewDates.start && calendarViewDates.end) {
				handleViewChange({ start: calendarViewDates.start, end: calendarViewDates.end });
			}
	
			setTimeout(() => {
				dispatch(resetCalendar('isActivityUpdated', false));
			}, 500);
		}
	}, [dispatch, isActivityUpdated]);
	

	// Toggle Modal
	const toggle = () => {
		setModal(!modal);
		if (!modal) {
			setActivity(null);
			setIsEdit(false);
			setIsEditButton(true);
		}
	};
	const toggleMaintenance = () => {
		setModalMaintenance(!modalMaintenance);
		if (!modalMaintenance) {
			setActivity(null);
			setIsEdit(false);
			setIsEditButton(true);
		}
	};

	// Handle Date Click in Calendar
	const handleDateClick = arg => {
		const date = arg['date'];
		const modifiedDate = new Date(date);
		const modifiedData = { ...arg, date: modifiedDate };

		// setSelectedNewDay([date, date]);
		// setSelectedDay(modifiedData);
		// toggle();
	};

	// Handle Activity Click in Calendar
	const handleActivityClick = (arg) => {

		const activity_item = arg.event._def;
		setActivity(activity_item)
		setIsEdit(true);
		setIsEditButton(false);
		
		if (activity_item.extendedProps.activity_group.code === 'MNT') {
			setModalMaintenance(true);
		}
		else {
			setModal(true);
		}
	};



	// 	useEffect(() => {
	//     if (activity) {
	//         setModal(true); // Abrir el modal solo si `activity` contiene datos válidos
	//     }
	// }, [activity]);



	// Format date range
	// const formatDateRange = (start, end) => {
	// 	return end ? `${formatDate(start)} to ${formatDate(end)}` : formatDate(start);
	// };

	// Format date
	// const formatDate = date => {
	// 	const d = new Date(date);
	// 	const day = String(d.getDate()).padStart(2, '0');
	// 	const month = d.toLocaleString('default', { month: 'long' });
	// 	const year = d.getFullYear();
	// 	return `${day} ${month}, ${year}`;
	// };

	// Handle Delete Activity
	const handleDeleteActivity = () => {
		dispatch(onDeleteActivity(activity.id));
		setDeleteModal(false);
		toggle();
	};

	// Handle Drop Event in Calendar
	const onDrop = event => {
		const date = event.date;
		const modifiedDate = new Date(date);
		const draggedEl = event.draggedEl;

		if (draggedEl.classList.contains('external-event')) {
			const newActivity = {
				id: Math.floor(Math.random() * 1000),
				title: draggedEl.innerText,
				start: modifiedDate,
				className: draggedEl.className,
			};
			dispatch(onAddNewActivity(newActivity));
		}
	};

	// Handle Calendar View Change
	const handleViewChange = ({ start, end }) => {
		setCalendarViewDates({ start, end });

		const activity_group_id = selectedGroupItem?._id || null;
		const categories_list = categories ? categories.join(',') : '';
		dispatch(onGetActivityList({ start, end, activity_group_id, categories: categories_list }));
	};

	// Handle Group Item Selection
	const handleGroupItemSelected = optionSelected => {
		setSelectedGroupItem(optionSelected);
	};

	// Fetch activities when the selected group item changes
	useEffect(() => {
		if (calendarViewDates.start && calendarViewDates.end) {
			handleViewChange({ start: calendarViewDates.start, end: calendarViewDates.end });
		}
	}, [selectedGroupItem]);


	const renderEventContent = (eventInfo) => {
		return (
			<div title={eventInfo.event.title} style={{ whiteSpace: 'normal' }}>
				<b>{eventInfo.timeText}</b>
				<div>{eventInfo.event.title}</div>
			</div>
		);
	};
	

	return (
		<React.Fragment>
			<DeleteModal show={deleteModal} onDeleteClick={handleDeleteActivity} onCloseClick={() => setDeleteModal(false)} />
			<Row>
				<Col xs={12}>
					<Row>
						<Col xl={3}>
							<Card className="card-h-100">
								<CardBody>
									{!type && (
										<CreateActivityButton onClick={toggle} />
									)}

									{type == 'maintenance' ? (
										<CreateActivityMaintenanceButton onClick={toggleMaintenance} />
									) : null}

									<ActivityGroupList groups={groups} handleGroupItemSelected={handleGroupItemSelected} />
								</CardBody>
							</Card>
						</Col>
						<Col xl={9}>
							<Card className="card-h-100">
								<CardBody>
									<FullCalendarView
										upcomingActivities={activities}
										handleDateClick={handleDateClick}
										handleActivityClick={handleActivityClick}
										onDrop={onDrop}
										handleViewChange={handleViewChange}
										eventContent={renderEventContent}
									/>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<ActivityModal modal={modal} toggle={toggle} activity={activity} />
					<ActivityMaintenanceModal modal={modalMaintenance} toggle={toggleMaintenance} activity={activity} categories={categories} />
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default Calendar;
